import { createFileRoute } from "@tanstack/react-router";
import { Link } from "@tanstack/react-router";
import useAppStore from "@/store";
import { useSimpleForm } from "@/hooks/use-simple-form";
import { InputField } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { useTranslate } from "@/hooks/use-translate";
import ChangeLanguage from "@/components/ui/shared/change-language";
import { Alert } from "@/components/ui/alert";

export const Route = createFileRoute("/(onboarding)/auth/password-forgot")({
  component: PasswordForgot,
});

function PasswordForgot() {
  const store = useAppStore();
  const form = useSimpleForm({
    email: "",
  });
  const { t } = useTranslate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    store.errors.reset();
    store.loading.start("password_forgot");
    store.auth
      .passwordForgot(form.values.email)
      .then(() => {
        store.display.show("email_sended");
      })
      .catch((error: any) => store.errors.catch(error))
      .finally(() => {
        store.loading.stop("password_forgot");
      });
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <div className="w-1/2 hidden md:block relative overflow-hidden p-4 lg:p-0">
        <div className="absolute top-4 left-4">
          <img
            src="/assets/images/logo.svg"
            alt="SalesBox Logo"
            width={120}
            height={40}
          />
        </div>
        <div className="flex items-center justify-center h-screen">
          <img
            src="/assets/images/password-forgot.svg"
            alt="3D Character"
            className="w-3/5 max-h-full"
          />
        </div>
      </div>

      <div className="w-full md:w-1/2 flex items-center justify-center p-4 sm:p-8 mx-auto bg-white relative">
        <div className="absolute top-4 right-8">
          <ChangeLanguage />
        </div>
        <div className="w-full max-w-md">
          <h1 className="text-2xl  font-bold mb-2">
            {t("Forgot your password?")}
          </h1>
          <p className="text-gray-500 mb-8">
            {t(
              "Please provide your email address. If you have an account we will send you a password reset email"
            )}
          </p>
          <form className="space-y-4" onSubmit={handleLogin}>
            <div>{store.errors.render()}</div>
            <Alert
              name="email_sended"
              message={t(
                "Password reset email send with success. Check you inbox."
              )}
            />
            <div>
              <InputField
                label={t("Email")}
                name="email"
                value={form.values.email}
                onChange={form.handleChange}
              />
            </div>

            <Button
              className="w-full"
              type="submit"
              disabled={store.loading.status.password_forgot}
              loading={store.loading.status.password_forgot}
            >
              {t("Continue")}
            </Button>
          </form>
          <div className="mt-6 text-center">
            <p className="text-sm text-gray-500 flex justify-center gap-2">
              <Link
                to="/auth/login"
                className="text-primary-gray  hover:underline"
              >
                {t("Back to login")}
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
